module.exports = __webpack_public_path__ + "img/Legendary Eagle.32f12b3b.png";